import React, {Component} from 'react'
import ModalApp from '../../SharedComponents/Modal'
import UpdatedPricingPage from "./UpdatedPricingPage"

class UpdatedPricingModal extends Component {
    render() {
        return (
            <ModalApp name="updatedPricingModal"
                      header={null}
                      body={<UpdatedPricingPage />}
                      size="large"
            />
        )
    }
}

export default UpdatedPricingModal